import { render } from "./TabHeader.vue?vue&type=template&id=83b29cfc&scoped=true"
import script from "./TabHeader.vue?vue&type=script&lang=js"
export * from "./TabHeader.vue?vue&type=script&lang=js"

import "./TabHeader.vue?vue&type=style&index=0&id=83b29cfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83b29cfc"],['__file',"src/components/TabHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "83b29cfc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('83b29cfc', __exports__)) {
    api.reload('83b29cfc', __exports__)
  }
  
  module.hot.accept("./TabHeader.vue?vue&type=template&id=83b29cfc&scoped=true", () => {
    api.rerender('83b29cfc', render)
  })

}


export default __exports__